import React, { Component } from 'react'
import Link from '../utils/link'
import Slider from "react-slick";
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { ActionArrow } from './icons'

// Component to fix beforeChange bug rerendering slick
class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }  
  render() {
    return (<>{ this.props.children }</>)
  }
}

class WhyUsShowcase extends Component {

  render() {

    let { image, items , buttons} = this.props

     const settings = {
      speed: 600,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      cssEase: 'ease',
      swipe: false,
      focusOnSelect: false,
      adaptiveHeight: true,
      pauseOnHover: true
    }

    return (
      <section className='why-us-showcase'>
        <div className='why-us-showcase__inner'> 
          <div className='why-us-showcase__content'> 

            <div className='why-us-showcase__image'>
              <img loading='lazy' src={image?.sourceUrl} alt="" />
            </div>
      
            { items && 

              <div className='why-us-showcase__slides'>

                <BlockUpdate>

                  <Slider {...settings}>
                  
                    {items.map((el, i) => (

                      <div className='why-us-showcase__slide' key={i}>

                        <div className='why-us-showcase__details'>

                          { el.link &&
                            <Link to={el.link}>{el.text}</Link>
                          }

                          <h4 className='title'>{ el.title }</h4>

                          <div className='copy' dangerouslySetInnerHTML={{ __html: el.content }} />

                        </div>

                      </div>

                    ))}

                  </Slider>

                </BlockUpdate>

              </div>
            }


            { buttons &&

            <div className='why-us-showcase__buttons'>

              {buttons.map((el, i) => (
            
              <Link to={el.link} className='why-us-showcase__button'>
                <span>{ el.text }</span>
                <ActionArrow color='#FFFFFF'/>
              </Link>

              ))}
  
            </div>

            }

          </div>

        </div>
      </section>
    )
  }
}

export default WhyUsShowcase
